var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93233 8C6.04286 8 5.33334 8.71305 5.33334 9.5786C5.33334 10.4441 6.04286 11.1572 6.93233 11.1572H25.0677C25.9572 11.1572 26.6667 10.4441 26.6667 9.5786C26.6667 8.71305 25.9572 8 25.0677 8H6.93233ZM6.93233 14.4214C6.04286 14.4214 5.33334 15.1345 5.33334 16C5.33334 16.8655 6.04286 17.5786 6.93233 17.5786H25.0677C25.9572 17.5786 26.6667 16.8655 26.6667 16C26.6667 15.1345 25.9572 14.4214 25.0677 14.4214H6.93233ZM6.93233 20.8428C6.04286 20.8428 5.33334 21.5559 5.33334 22.4214C5.33334 23.287 6.04286 24 6.93233 24H25.0677C25.9572 24 26.6667 23.287 26.6667 22.4214C26.6667 21.5559 25.9572 20.8428 25.0677 20.8428H6.93233Z",
    fill: "#AAA8AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.737f588d1d50920289f6447f4821fabc.svg";
export { ForwardRef as ReactComponent };